import { Component } from '@angular/core';


@Component({
  templateUrl: './dashboard-page.html',
  styleUrls: ['dashboard-page.scss']
})
export class DashboardPageComponent {




}







// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/dashboard-page/dashboard-page.ts